import { CollectionTypes } from '@models/payments';

export const SubscriptionStates = {
  ACTIVE: 'active',
  CANCELED: 'canceled',
  NONE: 'none',
} as const;

export type SubscriptionState = (typeof SubscriptionStates)[keyof typeof SubscriptionStates];

export const SUBSCRIPTION_STATE_LABELS: Record<SubscriptionState, string> = {
  [SubscriptionStates.ACTIVE]: 'Active',
  [SubscriptionStates.CANCELED]: 'Canceled',
  [SubscriptionStates.NONE]: 'None',
};

export const CUSTOMER_PAYMENT_TYPE_LABELS: Record<string, string> = {
  [CollectionTypes.DEBT_COLLECTION]: 'Debt Collection',
  [CollectionTypes.SUBSCRIPTION_RECOVERY]: 'Recurring Recovery',
};

// Mirrors payments-api ChargerType (src/common/enums/charger/charger-type.enum.ts).
export const ScheduledPaymentChargerTypes = {
  RECURRING: 'recurring',
  OFFSET: 'offset',
  DEBT_COLLECTION: 'debt_collection',
} as const;

// Mirrors payments-api scheduledPaymentStatuses (src/common/constants/scheduled-payment-status.constant.ts).
export const SCHEDULED_PAYMENT_STATUS_LABELS: Record<string, string> = {
  upcoming: 'Upcoming',
  processing: 'Processing',
  'failed-and-rescheduled': 'Failed & rescheduled',
  'subscription-canceled': 'Subscription canceled',
  succeeded: 'Succeeded',
  failed: 'Failed',
  canceled: 'Canceled',
};
